export const SET_STRIKER_BY_TOURNAMENT = 'SET_STRIKER_BY_TOURNAMENT'